import {
  setExpiringCookies
} from './_cookies.js';
import Cookies from 'js-cookie'

export const promptEmailOptInModal = () => {
  if (Cookies.get("optInModal")) {
    if (Dillards.config.pageType !== 'layoutCheckout' && !$("#addedToWishlist-alert").length > 0) {
      $.ajax({
        url: "/webapp/wcs/stores/servlet/UserDemo",
        cache: false,
        type: "POST",
        data: "storeId=301&langId=-1&catalogId=301",
        beforeSend: function() {
          setExpiringCookies('optInModal', '', -1);
        },
        success: function() {
          Dillards.triggerModal('/webapp/wcs/stores/servlet/EmailOptInModalView', '', '.modal');
        },
        error: function() {
          Dillards.triggerModal('/webapp/wcs/stores/servlet/EmailOptInModalView', '', '.modal');;
        }
      });
    } else setExpiringCookies('optInModal', '', -1);
  }
};
